import { Stack, Label, TextField } from '@fluentui/react'

type DateRangeFilterProps = {
  startDate: string
  endDate: string
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
}

const DateRangeFilter = ({ startDate, endDate, onStartDateChange, onEndDateChange }: DateRangeFilterProps) => {
  return (
    <Stack horizontal tokens={{ childrenGap: 12 }} verticalAlign="end">
      <Stack>
        <Label>Start Date</Label>
        <TextField
          type="date"
          value={startDate}
          onChange={(_, val) => val !== undefined && onStartDateChange(val)}
          styles={{ root: { width: 160 } }}
        />
      </Stack>
      <Stack>
        <Label>End Date</Label>
        <TextField
          type="date"
          value={endDate}
          onChange={(_, val) => val !== undefined && onEndDateChange(val)}
          styles={{ root: { width: 160 } }}
        />
      </Stack>
    </Stack>
  )
}

export default DateRangeFilter
